:host {
    display: block;
}

uic-message-toast {
    @media only screen and (min-width: 1920px) {
        --uic-message-toast-width: 275px;
        --uic-message-toast-icon-size: 29px;
        --uic-message-toast-title-width: 192px;
        --uic-message-toast-title-padding: 6px;
    }

    @media only screen and (max-width: 1919px) {
        --uic-message-toast-width: 228px;
        --uic-message-toast-icon-size: 24px;
        --uic-message-toast-title-width: 152px;
        --uic-message-toast-title-padding: 8px;
    }

    @media only screen and (max-width: 1023px) {
        --uic-message-toast-width: 189px;
        --uic-message-toast-icon-size: 20px;
        --uic-message-toast-title-width: 118px;
        --uic-message-toast-title-padding: 10px;
    }

    --uic-icon-button-width: var(--uic-icon-dimensions-default);
    --uic-icon-button-height: var(--uic-icon-dimensions-default);
}

@keyframes newnotification {
    from {
        right: calc(-1 * var(--uic-message-toast-width));
    }

    to {
        right: 0;
    }
}

.uic-message-toast {
    &__container {
        flex-direction: column-reverse;
        display: flex;
    }

    &__message {
        width: var(--uic-message-toast-width);
        background: #fff;
        border: 1px solid var(--uic-color-blue4);
        box-shadow: 0 0 6px 0 var(--uic-color-blue6);
        clip-path: inset(-5px 1px -5px -15px);
        position: relative;
        margin-top: 8px;
        cursor: pointer;
        animation-duration: 0.1s;
        animation-name: newnotification;
        right: calc(0 - var(--uic-message-toast-width));
    }

    &__message--deleted {
        transition: 0.1s;
        transform: translateX(var(--uic-message-toast-width));
    }

    &__message--error {
        border: 1px solid var(--uic-color-red1);
        box-shadow: 0 0 4px 0 var(--uic-atom-shadow-color-error);
    }

    &__message--success {
        border: 1px solid var(--uic-color-green1);
        box-shadow: 0 0 4px 0 var(--uic-color-green1);
    }

    &__headline {
        display: flex;
        margin-top: 16px;
        pointer-events: none;
    }

    &__image {
        --uic-icon-width: var(--uic-message-toast-icon-size);
        --uic-icon-height: var(--uic-message-toast-icon-size);
        width: var(--uic-message-toast-icon-size);
        height: var(--uic-message-toast-icon-size);

        margin-left: calc(var(--uic-message-toast-icon-size) / -2);
    }

    &__title {
        padding-left: var(--uic-message-toast-title-padding);
        width: var(--uic-message-toast-title-width);
        height: 19px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        align-self: center;
        font-weight: var(--uic-font-weight-bold);
        color: var(--uic-color-blue4);
    }

    &__title--error {
        color: var(--uic-color-red2);
    }

    &__title--success {
        color: var(--uic-color-green1);
    }

    &__cross {
        width: var(--uic-message-toast-icon-size);
        height: var(--uic-message-toast-icon-size);
        margin-left: 8px;
        cursor: pointer;
        pointer-events: auto;
    }

    /* stylelint-disable declaration-property-value-disallowed-list, value-no-vendor-prefix, property-no-vendor-prefix */
    /* webkit not supported by IE, but currently no other good solution is available for multiline text with ellipsis.  */
    &__text {
        margin: 14px 16px 12px 20px;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        overflow: hidden;
        font-weight: var(--uic-font-weight-normal);
        pointer-events: none;
    }
    /* stylelint-enable declaration-property-value-disallowed-list, value-no-vendor-prefix, property-no-vendor-prefix */

    &__details-text {
        margin-left: 20px;
        margin-bottom: 18px;
        text-decoration: underline;
        text-underline-offset: 3px;
        color: var(--uic-color-blue4);
        cursor: pointer;
        pointer-events: auto;
    }
}
